import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import { WebhookEvents } from "@/lib/lazyPages";

export const Route = createFileRoute("/admin/webhook-events")({
  component: () => (
    <RouteGuard access={{ kind: "admin" }}>
      <WebhookEvents />
    </RouteGuard>
  ),
});
